import "./vendor/jquery-rails-4.4.0/jquery.js";
import "./vendor/jquery-rails-4.4.0/jquery_ujs.js";
import "./vendor/bootstrap-sass-3.4.1/bootstrap.min.js";
import "./vendor/jquery-inputmask-rails-2.5.5/jquery.inputmask.js";
import "./vendor/jquery-inputmask-rails-2.5.5/jquery.inputmask.extensions.js";
import "./vendor/jquery-inputmask-rails-2.5.5/jquery.inputmask.numeric.extensions.js";
import "./vendor/jquery-inputmask-rails-2.5.5/jquery.inputmask.date.extensions.js";
